<div class="wk-fup__field">
    <label class="wk-fup__field-label">{{ "JobsAndBilling.JobStatus" | translate }}</label>
    <div class="wk-fup__field-control">
        <kendo-dropdownlist-wrapper
            name="jobStatus"
            [data]="statusOptions()"
            textField="Name"
            valueField="Id"
            [value]="cardData()?.job?.statusId"
            (change)="changeStatus($event.target.value)"
            [disabled]="isStatusOptionsLoading()"
            [readonly]="!canEditStatus()"
            [tooltipIfReadonly]="'Tooltips.DisabledJobsSecurity'"
            class="wk-fup__field-select"
        />
        @if (isStatusOptionsLoading()) {
            <app-loader class="wk-fup__field-loader" [isOverlay]="false" size="small" [isLoading]="true" />
        }
    </div>
</div>
<div class="wk-fup__field">
    <label class="wk-fup__field-label">{{ "CardModal.Column" | translate }}</label>
    <div class="wk-fup__field-title">
        @let _stepName = stepName() | wkTranslate;
        {{ _stepName?.length > 15 ? (_stepName | slice: 0 : 15) + "..." : _stepName }}
        @if (_stepName?.length > 15) {
            <tooltip-pds3 mode="indicator" [openDelay]="600" [closeDelay]="50" position="bottom" targetSelector=".wk-fup__field-title">
                {{ _stepName }}
            </tooltip-pds3>
        }
    </div>
</div>
<div class="wk-fup__field">
    <label class="wk-fup__field-label">{{ "JobsAndBilling.Priorities.Priority" | translate }}</label>
    <kendo-dropdownlist-wrapper
        name="priority"
        [data]="priorityOptions"
        textField="label"
        valueField="value"
        [value]="cardData()?.job?.priority"
        (change)="changePriority($event.target.value)"
        [readonly]="!canEditPriority()"
        [tooltipIfReadonly]="'Tooltips.DisabledJobsSecurity'"
        class="wk-fup__field-select"
    />
</div>
